export default __webpack_public_path__ + "static/media/file-text.fcc991a8.svg";